import { ADMIN_TAB_GROUPS } from 'data/admin-tabs';
import { AdminTabContext, AdminTabGroup } from 'types/admin-tabs';

export function findAdminTabContext(index: number): AdminTabContext | null {
  for (const group of ADMIN_TAB_GROUPS) {
    const tab = group.tabs.find((t) => t.index === index);
    if (tab) {
      return { groupLabel: group.label, tabName: tab.name };
    }
  }
  return null;
}

export function adminTabGroupLabel(
  group: AdminTabGroup,
  activeTabIndex: number
): string {
  const activeTab = group.tabs.find((tab) => tab.index === activeTabIndex);
  return activeTab ? `${group.label}: ${activeTab.name}` : group.label;
}
